import { DEFAULT_HOTKEYS } from 'enums'

export default {
  ...DEFAULT_HOTKEYS,
}
